import PropTypes from 'prop-types'
import './typography.scss'

export default function StrongSecondary({ children, className, ...props }) {
  return (
    <span className={`txt-secondary txt-strong ${className ? className :''}`} {...props}>
      {children}
    </span>
  )
}

StrongSecondary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}